import { OpenDialogHelpComponent } from './../../dialog/open-dialog-help/open-dialog-help.component';
import { DOCUMENT } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { faHeart as faHeartEmpty } from '@fortawesome/free-regular-svg-icons';
import { faHeart as faHeartFull } from '@fortawesome/free-solid-svg-icons';
import { OpendialogLoginComponent } from 'app/components/dialog/open-dialog-login/opendialog-login.component';
import { InfosUser } from 'app/shared/models/class/auth/infosUser';
import { Color } from 'app/shared/models/class/color/color';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { Tag } from 'app/shared/models/class/tags/tag';
import { WishList } from 'app/shared/models/class/wishlist/wishlist';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { ColorService } from 'app/shared/services/color/color.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { OfferService } from 'app/shared/services/offer/offer.service';
import { SessionBasketService } from 'app/shared/services/session-basket/session-basket.service';
import { TagService } from 'app/shared/services/tag/tag.service';
import { WishlistService } from 'app/shared/services/wishlist/wishlist.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';


@Component({
  selector: 'app-offer-home',
  templateUrl: './offer-home.component.html',
  styleUrls: ['./offer-home.component.scss']
})

export class OfferHomeComponent extends SubscriptionBaseComponent implements OnInit {

  faHeartEmpty = faHeartEmpty;
  faHeartFull = faHeartFull;
  faheart: object;

  searchForm: UntypedFormGroup;

  tags: Tag[] = [];
  tagsSelected: Tag[] = [];

  offers: FullOffer[];
  color: ThemePalette = 'primary';
  myWishes: FullOffer[];
  widthScreen: number;
  load: boolean;
  userConnected: InfosUser;
  moreTag = false;
  coordinatesSearch: any;
  valueInput: any;

  filteredByClub = false;

  private static readonly DEMO_THEME_CLASS = 'demo';
  private static readonly DEMO_THEME_LIGHT = 'light';
  private static readonly DEMO_THEME_DARK = 'dark';

  public theme: string;
  colorTheme: string;
  colorsTag: Color[];
  baseTags: any[];
  clubSelected = '';

  universeSelected: string | number;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private offerService: OfferService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private wishlistService: WishlistService,
    private sessionBasketService: SessionBasketService,
    private tagsService: TagService,
    private colorService: ColorService,
    private faIconService: FaiconService,
    @Inject(DOCUMENT) private document: Document) {
    super();
    this.theme = this.document.documentElement.classList.contains(OfferHomeComponent.DEMO_THEME_CLASS) ?
      OfferHomeComponent.DEMO_THEME_DARK : OfferHomeComponent.DEMO_THEME_LIGHT;
  }

  ngOnInit(): void {
    if (sessionStorage.getItem('clubCodeForHomeOffers')) {
      this.filteredByClub = true;
      this.clubSelected = sessionStorage.getItem('clubCodeForHomeOffers');
    }

    this.initComponent();
    this.initSub();
    this.initForm();
    this.getColorTags();

    const user = this.authService.getDecodedToken();
    const { universe } = this.route.snapshot.queryParams;
    // if ((user?.role !== 'admin' && user?.role !== 'Licence')) {
    //   this.router.navigate(['/home']);
    // }

    if (this.authService.isAuth()) {
      this.getWishlist();
      this.getBasketlist();
    }

    this.widthScreen = window.innerWidth;
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  reductHeader() {
    const header = document.getElementById('hearder_home');
    header.style.height = '100px';
  }

  getId(tag: string): string {
    const newTag = tag.toLowerCase().split(' ').join('_');
    return newTag;
  }

  getIdOfferAdd(offer: string): string {
    return `add_${offer.toLowerCase().split(' ').join('_')}`;
  }

  getIdOffer(index: number): string {
    return `offer_${index}`;
  }

  addOrDeleteToMyWish(offer: FullOffer, event): void {
    this.authService.refreshToken();
    const { offerKey } = offer;

    if (this.authService.isAuth()) {

      const { sub: userKey } = this.authService.getDecodedToken();
      const wishlistUpdate = new WishList(+userKey, []);

      wishlistUpdate.offerKey = this.myWishes.map(w => w.offerKey);

      const indexOfferInMyWishesUpdate = wishlistUpdate.offerKey.findIndex(o => o === offerKey);

      indexOfferInMyWishesUpdate === -1 ?
        (wishlistUpdate.offerKey.push(offerKey)) :
        (wishlistUpdate.offerKey.splice(indexOfferInMyWishesUpdate, 1));

      this.wishlistService.updateWishList(wishlistUpdate).subscribe({
        next: myWhishes => { this.dataService.myWishes.next(myWhishes); }
      });
    } else {
      const dialogRef = this.dialog.open(OpendialogLoginComponent);

      dialogRef.afterClosed().subscribe({
        next: () => {
          const { sub: userKey } = this.authService.getDecodedToken();
          const wishlistUpdate = new WishList(userKey, []);

          this.myWishes.forEach(wish => {
            wishlistUpdate.offerKey.push(wish.offerKey);
          });

          const indexOfferInMyWishesUpdate = wishlistUpdate.offerKey.findIndex(o => o === offerKey);

          indexOfferInMyWishesUpdate === -1 ?
            (wishlistUpdate.offerKey.push(offerKey)) :
            (wishlistUpdate.offerKey.splice(indexOfferInMyWishesUpdate, 1));

          this.wishlistService.updateWishList(wishlistUpdate).subscribe({
            next: myWhishes => { this.dataService.myWishes.next(myWhishes); }
          });
        }
      });
    }
  }

  isInMyWishes(offerId: string): object {
    const indexOfferInMyWhishes = this.myWishes?.findIndex(o => o.offerKey === +offerId);
    return indexOfferInMyWhishes === -1 ? this.faHeartEmpty : this.faHeartFull;
  }

  getColorOfHeart(offerId: string): string {
    const indexOfferInMyWhishes = this.myWishes?.findIndex(o => o.offerKey === +offerId);
    return indexOfferInMyWhishes === -1 ? '#2c296d !important' : '#ff0000';
  }



  openOfferInNewTab(offerKey: number) {
    const { structure, universe } = this.route.snapshot.queryParams;

    const queryParams = {
      offerKey,
      structure,
      universe
    };

    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/home/offer`], {
        queryParams
      })
    );

    window.open(url, '_blank');
  }

  goToUniverseWithQueryParam(universe: number): void {
    const { structure } = this.route.snapshot.queryParams;
    const user = this.authService.getDecodedToken();

    this.universeSelected = universe;
    this.getTags();

    if (structure) {
      this.router.navigate(['/home'], {
        queryParams: {
          structure,
          universe
        }
      });
    } else {
      this.router.navigate(['/home'], {
        queryParams: {
          universe
        }
      });
    }

    universe === 5 ? this.selectDarkTheme() : this.selectLightTheme();

    const tagString = this.tagsSelected.map(t => t.tagKey).join(';');

    const coordinates = this.formatCoord(this.coordinatesSearch) || '';
    this.getOfferWithTags(tagString, coordinates, universe);
  }

  addTag(tag: Tag): void {
    this.tagsSelected.push(tag);
    this.dataService.tagSelected$.next(this.tagsSelected);
    sessionStorage.setItem('tags', btoa(JSON.stringify(this.tagsSelected)));
    let allTagSelected = [];

    for (const item of this.tagsSelected) {
      const tags = this.baseTags.filter(t => t.tagName.trim() === item.tagName.trim());
      allTagSelected = [...allTagSelected, ...tags];
    }
    allTagSelected = [...new Set(allTagSelected)];

    const tagString = allTagSelected.map(t => t.tagKey).join(';');
    const coordinates = this.formatCoord(this.coordinatesSearch) || '';
    this.getOfferWithTags(tagString, coordinates);
  }

  removeTag(tag: Tag): void {
    const index = this.tagsSelected.findIndex(t => t.tagKey === tag.tagKey);
    this.tagsSelected.splice(index, 1);
    this.dataService.tagSelected$.next(this.tagsSelected);
    sessionStorage.setItem('tags', btoa(JSON.stringify(this.tagsSelected)));

    const tagString = this.tagsSelected.map(t => t.tagKey).join(';');
    const coordinates = this.formatCoord(this.coordinatesSearch) || '';

    this.getOfferWithTags(tagString, coordinates);
  }

  clickMoreTag(): void {
    const tags = document.getElementById('tags');
    tags.classList.replace('offers_filter_tags_reduce', 'offers_filter_tags_more');
    this.moreTag = true;
  }

  isInTagSelected(tag: string): boolean {
    const index = this.tagsSelected.findIndex(t => t.tagName === tag);
    return index === -1 ? true : false;
  }

  getAddressSearch(event): void {
    this.valueInput = this.f.keyword.value;
    this.coordinatesSearch = event;
    const cooordinates = this.formatCoord(event);
    const tagString = this.tagsSelected.map(t => t.tagKey).join(';');

    sessionStorage.setItem('coordinates', JSON.stringify(event));

    if (event) {
      this.getOfferWithTags(tagString, cooordinates);
    }

  }

  resetSearch(): void {
    this.f.keyword.reset();
    sessionStorage.removeItem('coordinates');
    this.valueInput = null;
    const tagString = this.tagsSelected.map(t => t.tagKey).join(';');
    this.getOfferWithTags(tagString, '');
  }

  universIsSelected(indexUniverse: number): boolean {
    const { universe } = this.route.snapshot.queryParams;
    let isSelected = false;

    if (+universe === indexUniverse || (!universe && indexUniverse === 1)) {
      isSelected = true;
    }
    return isSelected;
  }

  getValueColorTag({ colorKey }): string {
    return '#' + this.colorsTag?.find(c => c.colorKey === colorKey)?.value;
  }

  private selectDarkTheme(): void {
    this.document.documentElement.classList.add(OfferHomeComponent.DEMO_THEME_CLASS);
    this.dataService.themeDemo$.next(true);
    this.theme = OfferHomeComponent.DEMO_THEME_DARK;
  }

  private selectLightTheme(): void {
    const user = this.authService.getDecodedToken()?.name;
    if (user?.toLowerCase().includes('demo')) {
      this.selectDarkTheme();
    } else {
      this.document.documentElement.classList.remove(OfferHomeComponent.DEMO_THEME_CLASS);
      this.dataService.themeDemo$.next(false);
      this.theme = OfferHomeComponent.DEMO_THEME_LIGHT;
    }
  }

  private formatCoord(event): string {
    this.coordinatesSearch = event;
    const coordinates = [];

    switch (typeof event?.geometry?.location.lat) {
      case 'function':
        coordinates.push(event?.geometry.location.lat().toString().replace('.', ','));
        coordinates.push(event?.geometry.location.lng().toString().replace('.', ','));
        break;

      case 'number':
        coordinates.push(event?.geometry.location.lat.toString().replace('.', ','));
        coordinates.push(event?.geometry.location.lng.toString().replace('.', ','));
        break;

      default:
        break;
    }

    return coordinates.join(';');
  }

  private animationStartOffer(): void {
    let index = 0;
    if (index < 8) {
      setInterval(() => {
        const offer = document.getElementById(`offer_${index}`);
        offer?.classList.remove('offer_start');
        index++;
      }, 300);
    }
  }

  private getOfferWithTags(tagString: string, coordinates: string = '', universeChange?: number): void {
    this.offers = [];
    this.dataService.loadingOfferHome$.next(false);

    const structure = this.route.snapshot.queryParams.structure || '';
    let universe = universeChange ? +universeChange : (+this.route.snapshot.queryParams.universe || '');
    universe === 5 ? this.selectDarkTheme() : this.selectLightTheme();

    this.universeSelected = universe;

    if (!universe) {
      this.universeSelected = 1;
      universe = 1;
    }


    this.offerService.getOfferTag(tagString, coordinates, structure, +universe).subscribe({
      next: offers => {
        this.dataService.offersHome$.next(offers);
        this.dataService.loadingOfferHome$.next(true);
        setTimeout(() => {
          this.animationStartOffer();
        }, 500);
        window.scroll(0, 0);
      }
    });
  }

  private getWishlist(): void {
    const { sub: userKey } = this.authService.getDecodedToken();
    this.wishlistService.getWishList(+userKey).subscribe({
      next: wishes => this.dataService.myWishes.next(wishes)
    });
  }

  private getBasketlist(): void {
    const { sub: userKey } = this.authService.getDecodedToken();
    this.sessionBasketService.getBasketList(+userKey).subscribe({
      next: basket => this.dataService.myShoppingBag.next(basket)
    });
  }

  private getTags(): void {
    const tempoTag = [];
    this.tags = [];
    this.tagsService.getTagsByUniverse(this.universeSelected).subscribe({
      next: tags => {
        tags.forEach(t => {
          if (t.isActive) {
            t.tags.forEach(tag => {
              tempoTag.push(tag);
            });
          }
        });
        this.baseTags = [...tempoTag];

        for (let i = 1; i < this.colorsTag?.length + 1; i++) {
          const colorOrder = this.colorsTag.find(c => c.order === i);
          const tempo = tempoTag.filter(t => t.colorKey === colorOrder.colorKey && t.isActive).sort((a, b) => a.tagName.toLowerCase() - b.tagName.toLowerCase());

          tempo.forEach(item => {
            const index = this.tags.findIndex(t => t.tagName.trim() === item.tagName.trim());
            if (index === -1) { this.tags.push(item); }
          });
          // this.tags = [...this.tags, ...tempo];
        }
      }
    });
  }

  private getColorTags(): void {
    this.colorService.getColors().subscribe({
      next: colorsTag => {
        this.colorsTag = colorsTag;
        this.getTags();
      }
    });
  }

  private async checkTagSelected() {

    let tagString = ' ';

    if (sessionStorage.getItem('tags')) {

      const tagsParse = await JSON.parse(atob(sessionStorage.getItem('tags')));
      const getTags = await tagsParse?.length ? tagsParse : ' ';

      this.dataService.tagSelected$.next(getTags);
      tagString = await this.tagsSelected.length ? this.tagsSelected.map(t => t.tagKey).join(';') : ' ';
    }

    let coordinates;
    if (sessionStorage.getItem('coordinates')) {
      const event = await JSON.parse(sessionStorage.getItem('coordinates'));
      coordinates = await event ? this.formatCoord(event) : '';
    }

    sessionStorage.getItem('tags') || sessionStorage.getItem('coordinates') ?
      this.getOfferWithTags(tagString, coordinates) :
      this.getOfferWithTags(' ');

  }

  get f() {
    return this.searchForm.controls;
  }

  private initForm(): void {
    let coordinates = null;
    if (sessionStorage.getItem('coordinates')) {
      coordinates = JSON.parse(sessionStorage.getItem('coordinates'));
      if (coordinates) {
        this.valueInput = coordinates.name;
      }
    }

    this.searchForm = this.formBuilder.group({
      keyword: [coordinates?.name || '', Validators.required]
    });

  }

  private initComponent(): void {
    this.dataService.tabHome$.next('home');
    this.dataService.titleHomePage.next('Trouver une activité');
    this.dataService.resetPopUp();

    if (sessionStorage.getItem('tags') && sessionStorage.getItem('tags') === 'W10=') {
      sessionStorage.removeItem('tags');
      this.tagsSelected = [];
    }

    this.checkTagSelected();

  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.myWishes.asObservable().subscribe({
          next: myWishes => { this.myWishes = myWishes; this.cdr.detectChanges(); }
        })
      )
      .add(
        this.authService.currentUser.subscribe({
          next: user => {
            this.userConnected = user;
          }
        })
      )
      .add(
        this.dataService.offersHome$.subscribe({
          next: offers => {
            this.offers = offers;
            setTimeout(() => {
              this.animationStartOffer();
            }, 500);
            this.cdr.detectChanges();
          }
        })
      )
      .add(
        this.dataService.tagSelected$.subscribe({
          next: tags => {
            this.tagsSelected = tags;
            this.cdr.detectChanges();
          }
        })
      )
      .add(
        this.dataService.loadingOfferHome$.subscribe({
          next: load => {
            this.load = load;
            this.cdr.detectChanges();
          }
        })
      );


  }

  openDialogHelp() {
    this.dialog.open(OpenDialogHelpComponent, {
      data: { helpVideoKey: 1 },
      width: '60%',
      maxHeight: '90%'
    });
  }

  resetFilter() {
    sessionStorage.removeItem('clubCodeForHomeOffers');
    this.filteredByClub = false;

    this.resetSearch();
  }
}

